import React, { useState, useEffect, useRef } from "react";
import { motion } from "framer-motion";

const BubbleZen = () => {
  const [bubbles, setBubbles] = useState([]);
  const [score, setScore] = useState(0);
  const [mute, setMute] = useState(false);
  const popSoundRef = useRef(null);
  const bgSoundRef = useRef(null);

  const createBubble = () => {
    const id = Math.random();
    setBubbles((prev) => [
      ...prev,
      {
        id,
        size: Math.random() * 50 + 40,
        x: Math.random() * 85,
        duration: Math.random() * 4 + 6,
      },
    ]);

    setTimeout(() => {
      setBubbles((prev) => prev.filter((bubble) => bubble.id !== id));
    }, 10000);
  };

  useEffect(() => {
    bgSoundRef.current.play().catch(() => {});
    const bubbleInterval = setInterval(createBubble, 1200);

    return () => clearInterval(bubbleInterval);
  }, []);

  // ✅ Automatic calm score every 10 seconds
  useEffect(() => {
    const calmInterval = setInterval(() => {
      setScore((s) => s + 1); // +1 every 10 seconds
    }, 10000);

    return () => clearInterval(calmInterval);
  }, []);

  const popBubble = (id) => {
    setBubbles((prev) => prev.filter((b) => b.id !== id));
    setScore((s) => s + 1); // bubble pop score
    if (!mute) popSoundRef.current.play();
  };

  return (
    <div
      className="min-h-screen w-full relative overflow-hidden flex flex-col items-center justify-center text-center"
      style={{
        background: "linear-gradient(120deg,#bae6fd,#d8b4fe,#fecdd3)",
      }}
    >
      <audio ref={bgSoundRef} src="/wildflowers.mp3" loop />
      <audio ref={popSoundRef} src="/pop.mp3" />

      <motion.h1
        className="text-5xl font-bold text-indigo-700 drop-shadow mb-2"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
      >
        Zen Bubble Pop
      </motion.h1>

      <p className="text-gray-700 mb-6 text-lg">Tap bubbles gently — breathe, relax</p>

      <div className="text-2xl font-semibold text-purple-800 bg-white/60 px-6 py-2 rounded-full shadow">
        ✨ Calm Score: {score}
      </div>

      {bubbles.map((b) => (
        <motion.div
          key={b.id}
          onClick={() => popBubble(b.id)}
          className="absolute bg-white/60 backdrop-blur-xl shadow-xl rounded-full cursor-pointer"
          style={{
            width: b.size,
            height: b.size,
            left: `${b.x}%`,
          }}
          animate={{ y: "-120vh", opacity: [0.9, 1, 0.4] }}
          transition={{ duration: b.duration, ease: "easeOut" }}
          whileTap={{ scale: 0.6 }}
        />
      ))}

      <button
        className="absolute top-4 right-4 bg-white/70 px-4 py-2 rounded-lg text-sm shadow"
        onClick={() => {
          mute ? bgSoundRef.current.play() : bgSoundRef.current.pause();
          setMute(!mute);
        }}
      >
        {mute ? "🔊 Sound On" : "🔇 Mute"}
      </button>
    </div>
  );
};

export default BubbleZen;
